import { BaseEntitiesService, createSingleton, repo } from '@bi/core';

export interface IRawPasswordPolicy {
  readonly id: number;
  readonly ident: string;
  readonly change_every: string;
  readonly min_length: number;
  readonly must_change: number;
  readonly uniqs: number;
  readonly capital_letters: number;
  readonly digits: number;
  readonly forbid_reuse: number;
  readonly specials: number;
  readonly valid_during: any;    //               
}

class PasswordPoliciesRepository extends repo.BaseRepository<IRawPasswordPolicy> {
  public constructor() {
    super('adm', 'password_policies');
  }
}

export class PasswordPoliciesService extends BaseEntitiesService<IRawPasswordPolicy> {
  protected constructor() {
    super(new PasswordPoliciesRepository());
  }
  public static getInstance: () => PasswordPoliciesService = createSingleton<PasswordPoliciesService>(() => new PasswordPoliciesService(), '__passwordPoliciesService');
}